import axios from 'axios';
import { ACCESS_KEY, BASE_URL } from 'core/utilities';

axios.defaults.baseURL = BASE_URL;

axios.interceptors.request.use(config => {
    const token = localStorage.getItem(ACCESS_KEY);
    if(token) config.headers!.Authorization = `Bearer ${token}`;
    return config;
}, error => {
    return Promise.reject(error);
});

export { axios };
